import type { RootState } from 'client/js/redux';
import { createSelector } from 'reselect';
import { INIT_MICRO_FRONTEND_STATE, INIT_STATE } from '../reducers/MicroFrontendsReducer';
import type {
  AlertNotificationsConfig,
  DiscoDashboardConfig,
  JourneysCreativeOptimizationConfig,
  LinkManagerConfig,
  MicroFrontendsReducer,
  PostbacksFormConfig,
  QltConfig,
  QrCodeCustomizationsConfig,
  UsageConfig,
} from '../types/microFrontendReducerTypes';

export function getMicroFrontendsState(state: RootState): MicroFrontendsReducer {
  return (state && state.micro_frontends) || INIT_STATE;
}

export const getMicroFrontendsVersions: (state: RootState) => Record<string, string> = createSelector(
  getMicroFrontendsState,
  (state) => state && state.versions
);

export const getQuickLinkTemplateMicroFrontendConfig: (state: RootState) => QltConfig = createSelector(
  getMicroFrontendsState,
  (state) => (state && state.qlt) || INIT_MICRO_FRONTEND_STATE
);

export const getLinkManagerConfig: (state: RootState) => LinkManagerConfig = createSelector(
  getMicroFrontendsState,
  (state) => (state && state.linkManager) || INIT_MICRO_FRONTEND_STATE
);

export const getJourneysCreativesOptimizationConfig: (state: RootState) => JourneysCreativeOptimizationConfig =
  createSelector(
    getMicroFrontendsState,
    (state) => (state && state.journeysCreativesOptimization) || INIT_MICRO_FRONTEND_STATE
  );

export const getPostbacksFormConfig: (state: RootState) => PostbacksFormConfig = createSelector(
  getMicroFrontendsState,
  (state) => (state && state.postbacksForm) || INIT_MICRO_FRONTEND_STATE
);

export const getAlertNotificationsConfig: (state: RootState) => AlertNotificationsConfig = createSelector(
  getMicroFrontendsState,
  (state) => (state && state.alertNotifications) || INIT_MICRO_FRONTEND_STATE
);

export const getQrCodeCustomizationsConfig: (state: RootState) => QrCodeCustomizationsConfig = createSelector(
  getMicroFrontendsState,
  (state) => (state && state.qrCodeCustomizations) || INIT_MICRO_FRONTEND_STATE
);

export const getUsageConfig: (state: RootState) => UsageConfig = createSelector(
  getMicroFrontendsState,
  (state) => (state && state.usage) || INIT_MICRO_FRONTEND_STATE
);

export const getDiscoDashboardConfig: (state: RootState) => DiscoDashboardConfig = createSelector(
  getMicroFrontendsState,
  (state) => (state && state.discoDashboard) || INIT_MICRO_FRONTEND_STATE
);

export const isLoading: (state: RootState) => boolean = createSelector(
  getMicroFrontendsState,
  (state) => state && state.isLoading
);

export const getIsJourneysCreativesOptimizationEnabled: (state: RootState) => boolean = createSelector(
  isLoading,
  getJourneysCreativesOptimizationConfig,
  (isMfeLoading, config) => !isMfeLoading && config?.url !== null
);

export const getIsLinkTemplatesEnabled: (state: RootState) => boolean = createSelector(
  isLoading,
  getQuickLinkTemplateMicroFrontendConfig,
  (isMfeLoading, config) => !isMfeLoading && config?.url !== null
);
